<template>
  <div class="special">
    <h3 class="page-header">
      <img src="../../assets/img/lab/special/title.png" alt="研究開発の落とし穴">
    </h3>
    <div class="introduction">
      <h4 class="introduction-title">
        <img src="../../assets/img/lab/special/sub_title.png" alt="研究開発の落とし穴とは？">
      </h4>
      私たちクレハは「どこにも無ければ、創ればいい」<br>
      「ナケレバ、ツクレバ。」の精神で<br>
      自社開発にこだわって様々な研究を重ねてきました。<br>
      全ての研究開発に言えることですが、世の中にまだ無いものを生み出す過程には、<br>
      うまくいかないことが無数にあるものです。<br>
      ここでは、クレハが75年に渡る歴史の中で経験した「落とし穴」の数々と、<br>
      そこから生まれた気づきと成長をご紹介します。
    </div>
    <div class="proverb">
      <img src="../../assets/img/lab/special/proverb01.png" alt="私は失敗したことがない。">
    </div>
    <div class="contents">
      <SpecialArticle :titleImage="require('../../assets/img/lab/special/headline01.jpg')" :image="require('../../assets/img/lab/special/img01.jpg')" text="クレハの前身である呉羽化学は、1962年頃からフッ素樹脂「KFポリマー」の研究開発に取り組んだ。当時、フッ素樹脂としては「テフロン」がすでによく知られていたが、テフロンがエチレンの四つの水素をすべてフッ素で置換した四フッ化エチレンであるのに対し、KFポリマーは二つを置換したポリフッ化ビニリデン。耐熱性、耐薬品性、撥水性、耐油性などの面で優れた性能を持つ上、汎用の合成樹脂とほぼ同じように成形加工ができるなど、良好な加工性も持ち合わせている。さらに、極性や誘電率が高いことも確認された。<i class='underline'>あまりに優秀な性質のために研究分野が分散し、商品目標を絞りきれないという問題が発生。</i>様々な技術分野での応用が試みられたが、商品としての収益性が見込めるものではなかった。そんな中、ある研究員が研究室でKFポリマーから糸を引き、それを持って趣味である釣りに出かけると意外な釣果を上げた。それをきっかけにすぐ「漁労用糸」の特許を出願し、これを基本特許に釣り糸「シーガー」が誕生。現在でも釣り人に愛される人気商品に成長した。" />
      </div>
      <div class="contents">
      <SpecialArticle :titleImage="require('../../assets/img/lab/special/headline02.jpg')" :image="require('../../assets/img/lab/special/img02.jpg')" text="1995年、呉羽化学の農薬・農材研究室で“アングラ研究”として進んでいた育毛剤研究が表舞台に浮上。タマリンドガム（食品増粘剤、水溶性高分子）による発毛促進効果が発見されてからは、生活関連事業部のマーケティング部員や生物医学研究所の研究員らも加わって開発が本格化。その後、ポリビニルアルコールに発毛活性があることがわかり、これをもとに薬用育毛剤をつくって2本セットで売り出すというコンセプトがまとまった。社内ボランティア81人の協力で行った使用試験でも市販剤を超える成績を収めた。98年には国内化粧品メーカーとの間でOEM契約が結ばれ、商品化が決定。発売当初は予定の30万セットを上回る49万セットが出荷され、新聞広告やテレビCMを通じた積極的な宣伝活動や1万人のモニターキャンペーンなどを展開し、成功を収めた。しかし、薬事法上の制約から2本セットの使用による顕著な効果を訴求することができず、競合他社との差別化が難航。何よりも、2本を朝晩交互に使用する煩わしさや使用感（べとつき、ごわつき）などのマイナス面が目立ち、2000年には販売が停止してしまった。<i class='underline'>「性能が良ければ売れるはず」というプロダクトアウトの思考ばかりに依存せず、市場を十分理解した上で顧客の心をとらえることの重要性</i>を学んだ事例であり、この気づきは今のクレハにも生かされている。" />
      </div>
      <div class="contents">
      <SpecialArticle :titleImage="require('../../assets/img/lab/special/headline03.jpg')" :image="require('../../assets/img/lab/special/img03.jpg')" text="加水分解性を有し、PETの100倍高いガスバリア性とスーパーエンプラと同等以上の強度をもつPGA樹脂。クレハが世界で初めて工業生産に成功した。しかし、用途開発にはことごとく難航。まず、ガスバリア性を活かして炭酸飲料用のボトルとしての用途での売り込みを開始したが、物流の発達やリサイクルシステムの普及により、PGAの出番はなかった。医療用の縫合糸としての用途も検討したが、シェアトップの牙城を崩せなかった。<i class='underline'>活路は意外なところにあった。シェールオイル・ガスの採掘現場におけるフラックボールとフラックプラグである。</i>強度や分解性という点で現場のニーズに合致したPGAは、現在では製造から販売までをクレハが担う一大事業に成長した。" />
      <div class="proverb">
        <img src="../../assets/img/lab/special/proverb02.png" alt="私は失敗したことがない。">
      </div>
    </div>
  </div>
</template>

<script>
import SpecialArticle from "@/components/lab/SpecialArticle.vue"
export default {
  name: 'special',
  components: {
    SpecialArticle
  },
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.contents'));
    this.startIntersectionObserver(targets);
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  background-color: #3fae00;
  text-align: center;
  padding: 100px 0;
  margin: 0;
  @media print,screen and (max-width: 767px) {
    padding: 50px 0;
  }
  img {
    max-width: 900px;
    width: 90%;
  }
}
.introduction {
  border-top: 5px solid #00797f;
  border-bottom: 5px solid #00797f;
  position: relative;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  color: #00797f;
  padding: 100px 5%;
  @media print,screen and (max-width: 900px) {
    font-size: 16px;
    padding: 50px 5%;
  }
  br {
    @media print,screen and (max-width: 900px) {
      display: none;
    }
  }
  .introduction-title {
    content: "";
    max-width: 750px;
    width: 90%;
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
    transform: translateY(-55%);
    img {
      vertical-align: middle;
    }
  }
}
.proverb {
  background-color: #3fae00;
  text-align: center;
  padding: 100px 0;
  img {
    max-width: 600px;
    width: 90%;
  }
}
.contents {
  width: 100%;
  margin: 0 auto;
  position: relative;
  ::v-deep .title {
    opacity: 0;
    transform: rotateY(180deg);
    transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);
  }
  ::v-deep .image {
    opacity: 0;
    transform: translateY(100px);
    transition: all 1s cubic-bezier(0.77, 0, 0.175, 1) 1s;
  }
  &:before {
    content: "";
    width: 3%;
    height: 100%;
    left: 0;
    display: block;
    position: absolute;
    background: linear-gradient(
    -45deg,
    #00797f 25%, #47989c 25%,
    #47989c 50%, #00797f 50%,
    #00797f 75%, #47989c 75%);
    background-size: 60px 60px;
  }
  &:after {
    content: "";
    width: 3%;
    height: 100%;
    right: 0;
    top: 0;
    display: block;
    position: absolute;
    background: linear-gradient(
    -45deg,
    #00797f 25%, #47989c 25%,
    #47989c 50%, #00797f 50%,
    #00797f 75%, #47989c 75%);
    background-size: 60px 60px;
  }
  &.is-show {
    ::v-deep .title {
      transform: rotateY(0deg);
      opacity: 1;
    }
    ::v-deep .image {
      opacity: 1;
      transform: translateY(0px);
    }
  }
}
.special_article + .proverb {
  margin-top: 100px;
  img {
    width: 80%;
  }
}
</style>